/* =============================================================================
 * ASSETS DE /mexico — TODO sale de `@/assets/manifest` (dominio FORGE-BRAVO)
 * -----------------------------------------------------------------------------
 * Antes esta página importaba los PNG de `assets-source/generated/` a pelo:
 * Vite los servía tal cual y `/mexico` bajaba ~10,5 MB de PNG en crudo. El
 * manifiesto trae, por cada pieza, sus derivadas AVIF/WebP con anchuras reales
 * para `srcset` y un fallback JPEG/PNG — todas por debajo de 400 KB.
 *
 * Aquí no hay rutas: sólo CLAVES del manifiesto con nombre de página, para que
 * las secciones hablen de `heroLandmark` y no de una cadena suelta. Quien las
 * pinta es `ResponsiveImage` (substrato de FORGE-ALPHA), que además pone el
 * `alt` del manifiesto: ninguna imagen puede quedarse sin él.
 *
 * El emblema de marca NO está aquí: `Brandmark` ya lo trae de serie desde
 * `marca/*` (ADR-002). La página no vuelve a inyectarlo.
 * ========================================================================== */

import type { AssetKey } from '@/assets/manifest';

export const mexicoMedia = {
  /** Ángel de la Independencia + bandera + skyline. Zona derecha de cielo limpio. */
  heroLandmark: 'mexico/hero',
  /** Retrato real de Azrahel recortado con alfa (ADR-004: la cara no se genera). */
  heroPortrait: 'azrahel/recorte',
  /** Interior de la Cámara Cuántica: portal dorado, zona alta clara para el texto. */
  quantumChamber: 'mexico/camara',
  /** Skyline de CDMX con volcán al fondo — pie de la columna "un viaje de dos días". */
  journeySkyline: 'mexico/viaje-skyline',
  /** Marco vegetal dorado sobre crema — fondo de la banda de entradas. */
  leafFrame: 'mexico/ornamento-hojas',
} as const satisfies Record<string, AssetKey>;
